import request from '@/utils/request';

// 获取中奖列表
export function getWinningRecordLists(data) {
  return request({
    url: '/wap/winning/get_winning_record_lists',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取镇街排行榜
export function getWinningRecordInfo(data) {
  return request({
    url: '/wap/winning/get_winning_record_info',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
